.overlay {
  --narration-bottom-safe-zone: 6.25rem;
  position: absolute;
  z-index: 100;
  inset: 0;
  color: #f5ead7;
  pointer-events: none;
}

.overlay,
.overlay *,
.overlay *::before,
.overlay *::after {
  box-sizing: border-box;
}

.card {
  position: absolute;
  display: grid;
  width: min(34rem, calc(100% - 2rem));
  height: min(30rem, calc(100dvh - 7rem));
  max-height: min(calc(100% - 2rem), calc(100dvh - 7rem));
  grid-template-rows: auto minmax(0, 1fr) auto auto auto;
  gap: 0.85rem;
  padding: clamp(0.95rem, 2vw, 1.3rem);
  overflow: hidden;
  border: 1px solid rgb(237 209 163 / 28%);
  border-left: 3px solid #bc7043;
  border-radius: 0.3rem;
  background: linear-gradient(145deg, rgb(23 17 13 / 94%), rgb(11 10 9 / 91%)), rgb(13 11 9 / 94%);
  box-shadow:
    0 1.4rem 4rem rgb(0 0 0 / 46%),
    inset 0 1px rgb(255 244 223 / 7%);
  pointer-events: auto;
  backdrop-filter: blur(18px) saturate(0.8);
  animation: cardArrival 320ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
}

.upperLeft .card {
  top: 1rem;
  left: 1rem;
}

.upperRight .card {
  top: 1rem;
  right: 1rem;
}

.middleLeft .card {
  top: min(50%, calc((100dvh - 4.5rem) / 2 - 3.5rem));
  left: 1rem;
  transform: translateY(-50%);
}

.middleRight .card {
  top: min(50%, calc((100dvh - 4.5rem) / 2 - 3.5rem));
  right: 1rem;
  transform: translateY(-50%);
}

.lowerLeft .card {
  top: auto;
  bottom: var(--narration-bottom-safe-zone);
  left: 1rem;
  transform: none;
}

.lowerRight .card {
  right: 1rem;
  top: auto;
  bottom: var(--narration-bottom-safe-zone);
  transform: none;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgb(237 209 163 / 14%);
}

.eyebrow {
  display: block;
  margin-bottom: 0.2rem;
  color: #e0b96f;
  font-size: 0.67rem;
  font-weight: 820;
  letter-spacing: 0.14em;
}

.header h2 {
  margin: 0;
  font-family: "Noto Serif SC", SimSun, serif;
  font-size: clamp(1.08rem, 2vw, 1.45rem);
  font-weight: 620;
  line-height: 1.35;
  white-space: nowrap;
}

.header h2.compactTitle {
  font-size: clamp(0.7rem, 1.35vw, 1.04rem);
  letter-spacing: -0.035em;
}

.progress {
  flex: none;
  padding: 0.28rem 0.5rem;
  border: 1px solid rgb(237 209 163 / 18%);
  color: rgb(245 234 215 / 68%);
  background: rgb(255 255 255 / 3%);
  font-size: 0.68rem;
  font-variant-numeric: tabular-nums;
}

.page {
  min-height: 0;
  max-height: none;
  padding-right: 0.35rem;
  overflow-y: auto;
  scrollbar-color: rgb(224 185 111 / 45%) transparent;
}

.page h3 {
  margin: 0 0 0.5rem;
  color: #f3d49c;
  font-family: "Noto Serif SC", SimSun, serif;
  font-size: 0.92rem;
  font-weight: 720;
  line-height: 1.5;
}

.page p {
  margin: 0;
  color: rgb(255 248 235 / 91%);
  font-family: "Noto Serif SC", SimSun, serif;
  font-size: clamp(0.78rem, 1.2vw, 0.9rem);
  line-height: 1.85;
  text-align: justify;
  white-space: pre-line;
}

.previewNotice {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.62rem 0.7rem;
  border: 1px solid rgb(224 185 111 / 14%);
  background: rgb(224 185 111 / 6%);
}

.previewNotice > span {
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: none;
  place-items: center;
  border: 1px solid rgb(224 185 111 / 28%);
  border-radius: 50%;
  color: #e0b96f;
  font-family: "Noto Serif SC", SimSun, serif;
  font-size: 0.72rem;
}

.previewNotice > div {
  min-width: 0;
}

.previewNotice strong {
  color: #e8cc97;
  font-size: 0.68rem;
  letter-spacing: 0.035em;
}

.previewNotice p {
  margin: 0.15rem 0 0;
  color: rgb(245 234 215 / 62%);
  font-size: 0.66rem;
  line-height: 1.45;
}

.previewNotice .formalCue {
  padding-top: 0.35rem;
  margin-top: 0.35rem;
  border-top: 1px solid rgb(224 185 111 / 13%);
  color: rgb(255 248 235 / 88%);
  font-family: "Noto Serif SC", SimSun, serif;
  font-size: 0.74rem;
  line-height: 1.55;
}

.audioControls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  padding: 0;
  margin: 0;
  border: 0;
}

.audioControls button,
.navigation button,
.emptyState button {
  min-height: 2.35rem;
  padding: 0.48rem 0.72rem;
  border: 1px solid rgb(237 209 163 / 24%);
  border-radius: 0.18rem;
  color: #f4e5ca;
  background: rgb(255 255 255 / 4%);
  cursor: pointer;
  font: inherit;
  font-size: 0.7rem;
  font-weight: 680;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    transform 160ms ease;
}

.audioControls button:hover:not(:disabled),
.audioControls button:focus-visible,
.navigation button:hover:not(:disabled),
.navigation button:focus-visible,
.emptyState button:hover:not(:disabled),
.emptyState button:focus-visible {
  border-color: rgb(244 214 158 / 68%);
  background: rgb(188 112 67 / 28%);
}

.audioControls button:focus-visible,
.navigation button:focus-visible,
.emptyState button:focus-visible,
.volumeControl input:focus-visible {
  outline: 2px solid #f3d49c;
  outline-offset: 2px;
}

.audioControls button:disabled,
.navigation button:disabled,
.emptyState button:disabled,
.volumeControl input:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.volumeControl {
  display: grid;
  min-width: min(13rem, 100%);
  flex: 1;
  grid-template-columns: auto minmax(4.5rem, 1fr) 2.4rem;
  align-items: center;
  gap: 0.48rem;
  color: rgb(245 234 215 / 65%);
  font-size: 0.66rem;
}

.volumeControl input {
  width: 100%;
  accent-color: #bc7043;
  cursor: pointer;
}

.volumeControl output {
  color: #e8cc97;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.navigation {
  display: grid;
  grid-template-columns: minmax(7rem, auto) 1fr auto;
  align-items: center;
  gap: 0.6rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgb(237 209 163 / 14%);
}

.previousKnowledgePoint {
  justify-self: start;
}

.pageActions {
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 0.45rem;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.pageActions > button:last-child {
  justify-self: end;
  border-color: rgb(188 112 67 / 68%);
  background: rgb(188 112 67 / 18%);
}

.pageDots {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.pageDots li {
  width: 0.42rem;
  height: 0.42rem;
  border: 1px solid rgb(245 234 215 / 35%);
  border-radius: 50%;
  background: transparent;
}

.pageDots .completedDot {
  border-color: #e0b96f;
  background: #e0b96f;
  box-shadow: 0 0 0 0.18rem rgb(224 185 111 / 10%);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.emptyState {
  display: grid;
  min-height: 10rem;
  place-items: center;
  gap: 1rem;
  color: rgb(245 234 215 / 72%);
  text-align: center;
}

.emptyState p {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.7;
}

@keyframes cardArrival {
  from {
    opacity: 0;
    filter: blur(3px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
}

.reducedMotion .card {
  animation: none;
}

@media (max-width: 760px) {
  .upperLeft .card,
  .upperRight .card,
  .middleLeft .card,
  .middleRight .card,
  .lowerLeft .card,
  .lowerRight .card {
    top: auto;
    right: 0.65rem;
    bottom: var(--narration-bottom-safe-zone);
    left: 0.65rem;
    width: auto;
    height: auto;
    max-height: calc(100% - var(--narration-bottom-safe-zone) - 0.65rem);
    grid-template-rows: none;
    transform: none;
  }

  .card {
    gap: 0.68rem;
    padding: 0.82rem;
  }

  .page {
    min-height: 6rem;
    max-height: min(29vh, 12rem);
  }

  .navigation {
    grid-template-columns: minmax(7rem, auto) minmax(2rem, 1fr) auto;
  }
}

@media (max-width: 460px) {
  .header {
    gap: 0.5rem;
  }

  .progress {
    padding-inline: 0.35rem;
    font-size: 0.62rem;
  }

  .previewNotice > span {
    display: none;
  }

  .volumeControl {
    flex-basis: 100%;
  }

  .navigation {
    grid-template-areas:
      "previous dots"
      "actions actions";
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .previousKnowledgePoint {
    grid-area: previous;
  }

  .pageDots {
    grid-area: dots;
    justify-content: flex-end;
  }

  .pageActions {
    grid-area: actions;
    width: 100%;
    justify-self: stretch;
  }

  .pageActions > button:last-child {
    flex: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }

  .audioControls button,
  .navigation button,
  .emptyState button {
    transition: none;
  }
}
